import React from "react";
import { Component } from "react";
import { Site, Dimmer } from "tabler-react";
import axios from "axios";
import { getAPISMaster } from '../functions/getLambdasEndpoints';
import API from '@aws-amplify/api';

/**
 * Clase que recibe el codigo de acceso de cognito y lo valida con las lambdas para verificar el logueo
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 09/07/2021
 */
class Auth extends Component {

	getUrlParameter = (name, url) => {
		name = name.replace(/[[]/, '[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(url);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	obtieneUrlPlataforma = async (username) => {
		try {
			let respuesta = {status: false, data: {nivel: []}};
			const niveles = [{nombre: 'Licenciatura', key: 'lic'}, {nombre: 'Maestría', key: 'mtr'}, {nombre: 'Doctorado', key: 'doc'}, {nombre: 'Onsite', key: 'onsite'}];
			for (let nivel of niveles) {
				const [apiUrlPlataforma] = await  Promise.all([
					axios.get(getAPISMaster().apis.getUrlPlataforma.endpoint, { params: {userName: username, level: nivel.nombre } })
				]);
				if (apiUrlPlataforma.status === 200) {
					if("loginurl" in apiUrlPlataforma.data.url) {
						//respuesta.data.nivel = nivel.key;
						//respuesta.status = true;
						//break;
						if (respuesta.data.nivel.indexOf(nivel.key) === -1) {
							respuesta.data.nivel.push(nivel.key);
						}
						respuesta.status = true;
					}
				}
			}
			return respuesta;
		} catch (error) {
			console.log(error)
		}
	}

	validaDocenteBlackboard = async (email) => {
		let respuesta = {status: false, message: '¡Ups! Hubo un error al verificar si el docente pertenece a blackboard', data: {isBlackboard: false, userId: null}};
		try {
			if (localStorage.getItem("blackboard") === null) {
				const [respuestaDocenteBlackboard] = await Promise.all([
					API.get('apiValidaDocenteBlackboard', '/validaDocenteBlackboard', { queryStringParameters: {username: email} })
				]);
				let datosStorage = respuesta.data
				if (respuestaDocenteBlackboard.status) {
					let isBB = { isBlackboard: true, userId: respuestaDocenteBlackboard.data.blackboardId };
					datosStorage = isBB;
					respuesta = { status: true, data:  isBB };
				} else {
					delete respuesta.message;
					respuesta.status = true;
				}
				localStorage.setItem("blackboard", JSON.stringify(datosStorage));
			} else {
				respuesta = { status: true, data: JSON.parse(localStorage.getItem('blackboard')) }
			}
		} catch (error) { respuesta.message = error; }
		return respuesta;
	}

	componentDidMount = async () => {
		
		const url = window.location.origin + this.props.location.pathname + this.props.location.search;
		const code = this.getUrlParameter('code', url)
		const apiAuthLogin = await axios.post(getAPISMaster().apis.apiAuth.endpoint, {code: code, redirectUrl: window.location.origin + this.props.location.pathname} );
		if (apiAuthLogin.status === 200) {
			if (apiAuthLogin.data.status) {
				const fullname = apiAuthLogin.data.data.userInfo['custom:firstname'] + " " + apiAuthLogin.data.data.userInfo['custom:lastname'];
				const email = apiAuthLogin.data.data.userInfo['email'];
				const respuestaNivel = await this.obtieneUrlPlataforma(apiAuthLogin.data.data.userInfo['custom:username']);
				const datoLocalStorage = {fullname: fullname, username: apiAuthLogin.data.data.userInfo['custom:username'], email: email, nivel: null};
				// Valida si el docente tiene acceso a Moodle
				if (respuestaNivel.status) {
					datoLocalStorage['nivel'] = respuestaNivel.data.nivel;
				}
				// Valida si el Docente tiene acceso a Blackboard
				const isBlackBoard = await this.validaDocenteBlackboard(email)

				localStorage.setItem('profile', JSON.stringify(datoLocalStorage));
				localStorage.setItem('access_token', apiAuthLogin.data.data.access_token);
				window.location.href = "/";
			} else {
				window.location.href = "/";
			}
		} else {
			window.location.href = "/";
		}
	}

	render() {
		return (
			<Site>
				<Dimmer loader active />
			</Site>
		)
	}
}

export default Auth;